import { computed, makeObservable } from 'mobx';

import { ENDPOINTS } from 'configs/endpoints';
import { PlaceTypeEntity } from 'entities/PlaceType';
import { ProjectEntity, ProjectEntityApi, projectSchema } from 'entities/Project';
import { apiStore } from 'stores/global/ApiStore';
import { HandbookStore, HandbookStoreOptions } from 'stores/local/shared/HandbookStore';

import { PlaceTypeHandbookStore } from '../PlaceTypeHandbookStore';

type ProjectHandbookStoreOptions = Omit<HandbookStoreOptions<ProjectEntityApi>, 'entitySchema' | 'loadItems'> & {
  placeTypeHandbookStore: PlaceTypeHandbookStore;
};

export class ProjectHandbookStore extends HandbookStore<ProjectEntity, ProjectEntityApi> {
  private readonly _placeTypeHandbookStore: PlaceTypeHandbookStore;

  private readonly _request = apiStore.createRequest({
    url: ENDPOINTS.project.list,
  });

  constructor({ notificationStore, placeTypeHandbookStore }: ProjectHandbookStoreOptions) {
    super({
      loadItems: () => this._request.call(),
      entitySchema: projectSchema,
      notificationStore,
    });

    this._placeTypeHandbookStore = placeTypeHandbookStore;

    makeObservable(this, {
      itemsWithPlaces: computed,
    });
  }

  get itemsWithPlaces(): (ProjectEntity & { placeTypes: PlaceTypeEntity[] })[] {
    return this.items.map((item) => ({
      ...item,
      placeTypes: item.placeTypes.reduce<PlaceTypeEntity[]>((acc, { id }) => {
        const placeType = this._placeTypeHandbookStore.getItemByKey(id);

        if (placeType) {
          acc.push(placeType);
        }

        return acc;
      }, []),
    }));
  }
}
